import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPlanReviewSubmissionTypesQueryVariables = Types.Exact<{
  jurisdictionId: Types.Scalars['uuid']['input'];
}>;


export type GetPlanReviewSubmissionTypesQuery = { __typename?: 'query_root', plan_review_submission_types: Array<{ __typename?: 'plan_review_submission_types', id: any, code: string, name: string, short_name?: string | null }> };


export const GetPlanReviewSubmissionTypesDocument = gql`
    query getPlanReviewSubmissionTypes($jurisdictionId: uuid!) {
  plan_review_submission_types(
    where: {active: {_eq: true}, jurisdiction_id: {_eq: $jurisdictionId}}
    order_by: {sort_order: asc}
  ) {
    id
    code
    name
    short_name
  }
}
    `;

/**
 * __useGetPlanReviewSubmissionTypesQuery__
 *
 * To run a query within a React component, call `useGetPlanReviewSubmissionTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanReviewSubmissionTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanReviewSubmissionTypesQuery({
 *   variables: {
 *      jurisdictionId: // value for 'jurisdictionId'
 *   },
 * });
 */
export function useGetPlanReviewSubmissionTypesQuery(baseOptions: Apollo.QueryHookOptions<GetPlanReviewSubmissionTypesQuery, GetPlanReviewSubmissionTypesQueryVariables> & ({ variables: GetPlanReviewSubmissionTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanReviewSubmissionTypesQuery, GetPlanReviewSubmissionTypesQueryVariables>(GetPlanReviewSubmissionTypesDocument, options);
      }
export function useGetPlanReviewSubmissionTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanReviewSubmissionTypesQuery, GetPlanReviewSubmissionTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanReviewSubmissionTypesQuery, GetPlanReviewSubmissionTypesQueryVariables>(GetPlanReviewSubmissionTypesDocument, options);
        }
export function useGetPlanReviewSubmissionTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanReviewSubmissionTypesQuery, GetPlanReviewSubmissionTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlanReviewSubmissionTypesQuery, GetPlanReviewSubmissionTypesQueryVariables>(GetPlanReviewSubmissionTypesDocument, options);
        }
export type GetPlanReviewSubmissionTypesQueryHookResult = ReturnType<typeof useGetPlanReviewSubmissionTypesQuery>;
export type GetPlanReviewSubmissionTypesLazyQueryHookResult = ReturnType<typeof useGetPlanReviewSubmissionTypesLazyQuery>;
export type GetPlanReviewSubmissionTypesSuspenseQueryHookResult = ReturnType<typeof useGetPlanReviewSubmissionTypesSuspenseQuery>;
export type GetPlanReviewSubmissionTypesQueryResult = Apollo.QueryResult<GetPlanReviewSubmissionTypesQuery, GetPlanReviewSubmissionTypesQueryVariables>;